import React from 'react';
import * as queryString from 'querystring';
// import SocketManager from '../components/SocketManager';
import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';

class PayResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
  }

  componentDidMount() {
    const result = queryString.parse(this.props.location.search.replace('?', ''));
    console.log(result);
    localStorage.setItem('payResult', this.props.location.search);
    axiosInstance.post(`${WEB_API}/user/payInfo?evt=${EVENT_ID}&userId=${getUserID()}`, { payInfo: result }).then(() => {});
    // this.setState({ success: true }, () => {
    if (!window.opener) {
      window.opener = window.open('', 'PRS KOREA 2022');
    } else {
      //eslint-disable-next-line
      window.opener = window.opener;
    }
    window.opener.postMessage({ payResult: 'Success' }, '*');
    setTimeout(() => {
      window.close();
    }, 1000);
    // });
  }

  render() {
    return (
      <div>
        Please Wait ...
        {/*{this.state.success && <SocketManager type={'result'} />}*/}
      </div>
    );
  }
}

export default PayResult;
